export default "__VITE_ASSET__94bc4400__"